export class StatFetchingData {
  public nodeId!: number;
  public from!: Date;
  public to!: Date;
}
